import '../../core/components/app-root/AppRoot.css';
import './Main.css';
export var content = '_5zin931-3-5-0';
export var main = '_5zin930-3-5-0';
export var withDetails = '_5zin933-3-5-0';
export var withSidebar = '_5zin932-3-5-0';